import { render, staticRenderFns } from "./BaseInputPostalCode.vue?vue&type=template&id=2ae69492&"
import script from "./BaseInputPostalCode.vue?vue&type=script&lang=js&"
export * from "./BaseInputPostalCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports